import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/box-opened.png'


const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "inputs" }
const _hoisted_3 = {
  key: 0,
  class: "preview-container"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "user-list"
}
const _hoisted_6 = ["id", "checked", "onChange"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        id: "newProjectName",
        class: "inputStyle",
        placeholder: "Project Name",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.projectName) = $event))
      }, null, 512), [
        [_vModelText, _ctx.projectName]
      ]),
      _withDirectives(_createElementVNode("input", {
        id: "newProjectDescription",
        class: "inputStyle",
        placeholder: "Project Description",
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.projectDescription) = $event))
      }, null, 512), [
        [_vModelText, _ctx.projectDescription]
      ]),
      _createElementVNode("input", {
        id: "newProjectImage",
        class: "inputStyle",
        type: "file",
        accept: "image/*",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleProjectImage && _ctx.handleProjectImage(...args)))
      }, null, 32),
      (_ctx.isEditMode && _ctx.projectImageUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("img", {
              src: _ctx.projectImageUrl,
              class: "preview-image",
              alt: "Project Preview"
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "user-button",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showUserSelector = !_ctx.showUserSelector))
      }, _toDisplayString(_ctx.showUserSelector ? 'Hide' : 'Manage') + " Users ", 1),
      (_ctx.showUserSelector)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                key: user.user_id,
                class: "user-entry"
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  id: 'user-' + user.user_id,
                  checked: _ctx.isUserSelected(user.user_id),
                  onChange: ($event: any) => (_ctx.toggleUser(user.user_id))
                }, null, 40, _hoisted_6),
                _createElementVNode("label", {
                  for: 'user-' + user.user_id
                }, _toDisplayString(user.username) + " (" + _toDisplayString(user.email) + ")", 9, _hoisted_7)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      ref: "dropZone",
      class: _normalizeClass(["dropZone", { 'highlight': _ctx.isDragging }]),
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openFileDialog && _ctx.openFileDialog(...args)))
    }, [
      _cache[7] || (_cache[7] = _createElementVNode("img", {
        class: "dropImg",
        src: _imports_0,
        alt: ""
      }, null, -1)),
      _createElementVNode("label", {
        ref: "lblDropImages",
        class: _normalizeClass(["dropLabel", {'droplabel-upload':_ctx.uploading}])
      }, "Drop Images or Click", 2),
      (_ctx.uploading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.uploadProgress.current) + " / " + _toDisplayString(_ctx.uploadProgress.total) + " Sent Images ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        ref: "fileInput",
        type: "file",
        accept: ".png, .jpg, .jpeg, .gif, .bmp",
        multiple: "",
        style: {"display":"none"},
        onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args)))
      }, null, 544)
    ], 2),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        class: _normalizeClass({'cancelVisible':_ctx.isCancelVisible, 'cancelNotVisible':!_ctx.isCancelVisible}),
        color: "#d1d1d1",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isEditMode ? _ctx.saveChanges() : _ctx.CreateProject()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.isEditMode ? 'SAVE' : 'CREATE'), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(_component_Button, {
        class: _normalizeClass({'cancelVisible':_ctx.isCancelVisible, 'cancelNotVisible':!_ctx.isCancelVisible}),
        color: "red",
        onClick: _ctx.Cancel
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("CANCEL")
        ])),
        _: 1
      }, 8, ["class", "onClick"])
    ])
  ]))
}